import {BadgeCheck, CircleAlert, OctagonAlert} from "@lucide/vue";
import {GirerdInterpretation} from "@/medication-checkup/interfaces/girerd";

/**
 * How the reading of a Girerd score is shown, by its key: the tint of the
 * band and its icon, the same on every questionnaire.
 */
export const GIRERD_READINGS: Record<GirerdInterpretation['key'], {classes: string; icon: typeof BadgeCheck}> = {
    good: {classes: 'bg-secondary-lightest text-secondary-darkest', icon: BadgeCheck},
    minor: {classes: 'bg-orange/20 text-amber-800', icon: CircleAlert},
    poor: {classes: 'bg-red-light/15 text-red-700', icon: OctagonAlert},
};

/**
 * A reading with its first letter up, as a card titles it.
 */
export const girerdReadingTitle = (interpretation: GirerdInterpretation | null): string => {
    const label = interpretation?.label ?? '';

    return label.charAt(0).toUpperCase() + label.slice(1);
};
